
{{!-- linear-gradient(90deg, hsla({{color.h}}, {{color.s}}, {{color.l}}, 0.75) 25%, rgba(0,0,0,0) 100%) --}}

    {{#each civilizations}}
    <div class="info-panel__civ" style="background:hsla({{color.h}}, {{color.s}}, {{color.l}}, 0.5)">
        <div class="info-panel__civ-name">{{government.name}}</div>
    </div>
    {{/each}}
